import { Fields } from 'common/form';
import { EditJobCampaignDetails } from '../schemas/editJobCampaignDetailsSchema';

export const editJobCampaignDetailsFields: Fields<EditJobCampaignDetails> = {
  jobTitle: {
    label: 'Job title',
    subLabel: 'Also used for [job_title] variable.',
    type: 'text'
  },
  employerName: {
    label: 'Employer name',
    subLabel: 'Also used for [client name] variable.',
    type: 'text'
  },
  location: {
    label: 'Location',
    subLabel: 'Also used for [location] variable.',
    type: 'text'
  },
  contractType: {
    label: 'Contract type',
    subLabel:
      'E.g. full time, contract, shift. Add hours, working days and so on.',
    type: 'text'
  },
  additionalContext: {
    label:
      'Additional information not included in the job description (optional)',
    subLabel:
      'Popp will use any new or modified information for future conversations.',
    type: 'textarea',
    rows: 18
  },
  jobDescriptionText: {
    label: 'Job description',
    type: 'textarea',
    rows: 20.5
  }
};
